/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ConnectedInputs */

const en_common_connected = /** @type {(inputs: Common_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

const es_common_connected = /** @type {(inputs: Common_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado`)
};

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Common_ConnectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_connected = /** @type {((inputs?: Common_ConnectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ConnectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_connected(inputs)
	return en_common_connected(inputs)
});